var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 48,
    viewBox: "0 0 71 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99998 47.61H64.77C67.0722 47.4259 69.1134 46.0588 70.16 44H1.59998C2.64837 46.0617 4.69408 47.4293 6.99998 47.61Z",
    fill: "#B22234"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.909973 40.38V41.72C0.997617 42.5115 1.22801 43.2806 1.58997 43.99H70.14C70.5019 43.2806 70.7323 42.5115 70.82 41.72V40.38H0.909973Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.83 36.77H0.909973V40.38H70.83V36.77Z",
    fill: "#B22234"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.83 33.16H0.909973V36.77H70.83V33.16Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.83 29.55H0.909973V33.16H70.83V29.55Z",
    fill: "#B22234"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.83 25.94H0.909973V29.55H70.83V25.94Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.83 22.33H0.909973V25.94H70.83V22.33Z",
    fill: "#B22234"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.83 18.72H0.909973V22.33H70.83V18.72Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.83 15.11H0.909973V18.72H70.83V15.11Z",
    fill: "#B22234"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M70.83 11.49H0.909973V15.1H70.83V11.49Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M70.83 7.87997H0.909973V11.49H70.83V7.87997Z",
    fill: "#B22234"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.83 7.87998V6.53998C70.7435 5.74502 70.5131 4.97243 70.15 4.25998H1.59998C1.23686 4.97243 1.00644 5.74502 0.919983 6.53998V7.87998H70.83Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.76 0.659973H6.99999C4.69776 0.844022 2.65656 2.21114 1.60999 4.26997H70.16C69.1116 2.20826 67.0659 0.840663 64.76 0.659973Z",
    fill: "#B22234"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.09 25.94V0.659973H6.99996C3.82616 0.914057 1.27944 3.38525 0.929962 6.54997V25.94H34.09Z",
    fill: "#3C3B6E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01996 3.71997L4.74996 4.55997H3.86996L4.57996 5.06997L4.30996 5.90997L5.01996 5.38997L5.72996 5.90997L5.45996 5.06997L6.16996 4.55997H5.28996L5.01996 3.71997Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01996 7.95996L4.74996 8.79996H3.86996L4.57996 9.31996L4.30996 10.15L5.01996 9.63996L5.72996 10.15L5.45996 9.31996L6.16996 8.79996H5.28996L5.01996 7.95996Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01996 12.2L4.74996 13.04H3.86996L4.57996 13.56L4.30996 14.4L5.01996 13.88L5.72996 14.4L5.45996 13.56L6.16996 13.04H5.28996L5.01996 12.2Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01996 16.45L4.74996 17.28H3.86996L4.57996 17.8L4.30996 18.64L5.01996 18.12L5.72996 18.64L5.45996 17.8L6.16996 17.28H5.28996L5.01996 16.45Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28996 21.52L5.01996 20.69L4.74996 21.52H3.86996L4.57996 22.04L4.30996 22.88L5.01996 22.36L5.72996 22.88L5.45996 22.04L6.16996 21.52H5.28996Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50999 5.83997L7.23998 6.67997H6.35999L7.06999 7.19997L6.79999 8.02997L7.50999 7.50997L8.22998 8.02997L7.95999 7.19997L8.66999 6.67997H7.78999L7.50999 5.83997Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50999 10.08L7.23998 10.92H6.35999L7.06999 11.44L6.79999 12.27L7.50999 11.76L8.22998 12.27L7.95999 11.44L8.66999 10.92H7.78999L7.50999 10.08Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50999 14.33L7.23998 15.16H6.35999L7.06999 15.68L6.79999 16.52L7.50999 16L8.22998 16.52L7.95999 15.68L8.66999 15.16H7.78999L7.50999 14.33Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78999 19.4L7.50999 18.57L7.23998 19.4H6.35999L7.06999 19.92L6.79999 20.76L7.50999 20.24L8.22998 20.76L7.95999 19.92L8.66999 19.4H7.78999Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M10.01 3.71997L9.73999 4.55997H8.85999L9.56999 5.06997L9.29999 5.90997L10.01 5.38997L10.72 5.90997L10.45 5.06997L11.16 4.55997H10.28L10.01 3.71997Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M10.01 7.95996L9.73999 8.79996H8.85999L9.56999 9.31996L9.29999 10.15L10.01 9.63996L10.72 10.15L10.45 9.31996L11.16 8.79996H10.28L10.01 7.95996Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M10.01 12.2L9.73999 13.04H8.85999L9.56999 13.56L9.29999 14.4L10.01 13.88L10.72 14.4L10.45 13.56L11.16 13.04H10.28L10.01 12.2Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M10.01 16.45L9.73999 17.28H8.85999L9.56999 17.8L9.29999 18.64L10.01 18.12L10.72 18.64L10.45 17.8L11.16 17.28H10.28L10.01 16.45Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M10.28 21.52L10.01 20.69L9.73999 21.52H8.85999L9.56999 22.04L9.29999 22.88L10.01 22.36L10.72 22.88L10.45 22.04L11.16 21.52H10.28Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.83997L12.23 6.67997H11.35L12.06 7.19997L11.79 8.02997L12.5 7.50997L13.22 8.02997L12.95 7.19997L13.66 6.67997H12.78L12.5 5.83997Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.08L12.23 10.92H11.35L12.06 11.44L11.79 12.27L12.5 11.76L13.22 12.27L12.95 11.44L13.66 10.92H12.78L12.5 10.08Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.33L12.23 15.16H11.35L12.06 15.68L11.79 16.52L12.5 16L13.22 16.52L12.95 15.68L13.66 15.16H12.78L12.5 14.33Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M12.78 19.4L12.5 18.57L12.23 19.4H11.35L12.06 19.92L11.79 20.76L12.5 20.24L13.22 20.76L12.95 19.92L13.66 19.4H12.78Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3.71997L14.73 4.55997H13.85L14.56 5.06997L14.29 5.90997L15 5.38997L15.71 5.90997L15.44 5.06997L16.15 4.55997H15.27L15 3.71997Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.95996L14.73 8.79996H13.85L14.56 9.31996L14.29 10.15L15 9.63996L15.71 10.15L15.44 9.31996L16.15 8.79996H15.27L15 7.95996Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.2L14.73 13.04H13.85L14.56 13.56L14.29 14.4L15 13.88L15.71 14.4L15.44 13.56L16.15 13.04H15.27L15 12.2Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.45L14.73 17.28H13.85L14.56 17.8L14.29 18.64L15 18.12L15.71 18.64L15.44 17.8L16.15 17.28H15.27L15 16.45Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M15.27 21.52L15 20.69L14.73 21.52H13.85L14.56 22.04L14.29 22.88L15 22.36L15.71 22.88L15.44 22.04L16.15 21.52H15.27Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M17.49 5.83997L17.22 6.67997H16.34L17.05 7.19997L16.78 8.02997L17.49 7.50997L18.21 8.02997L17.93 7.19997L18.65 6.67997H17.77L17.49 5.83997Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M17.49 10.08L17.22 10.92H16.34L17.05 11.44L16.78 12.27L17.49 11.76L18.21 12.27L17.93 11.44L18.65 10.92H17.77L17.49 10.08Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M17.49 14.33L17.22 15.16H16.34L17.05 15.68L16.78 16.52L17.49 16L18.21 16.52L17.93 15.68L18.65 15.16H17.77L17.49 14.33Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M17.77 19.4L17.49 18.57L17.22 19.4H16.34L17.05 19.92L16.78 20.76L17.49 20.24L18.21 20.76L17.93 19.92L18.65 19.4H17.77Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M19.99 3.71997L19.72 4.55997H18.84L19.55 5.06997L19.28 5.90997L19.99 5.38997L20.7 5.90997L20.43 5.06997L21.14 4.55997H20.26L19.99 3.71997Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M19.99 7.95996L19.72 8.79996H18.84L19.55 9.31996L19.28 10.15L19.99 9.63996L20.7 10.15L20.43 9.31996L21.14 8.79996H20.26L19.99 7.95996Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M19.99 12.2L19.72 13.04H18.84L19.55 13.56L19.28 14.4L19.99 13.88L20.7 14.4L20.43 13.56L21.14 13.04H20.26L19.99 12.2Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M19.99 16.45L19.72 17.28H18.84L19.55 17.8L19.28 18.64L19.99 18.12L20.7 18.64L20.43 17.8L21.14 17.28H20.26L19.99 16.45Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M20.26 21.52L19.99 20.69L19.72 21.52H18.84L19.55 22.04L19.28 22.88L19.99 22.36L20.7 22.88L20.43 22.04L21.14 21.52H20.26Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M22.48 5.83997L22.21 6.67997H21.33L22.04 7.19997L21.77 8.02997L22.48 7.50997L23.2 8.02997L22.92 7.19997L23.64 6.67997H22.76L22.48 5.83997Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M22.48 10.08L22.21 10.92H21.33L22.04 11.44L21.77 12.27L22.48 11.76L23.2 12.27L22.92 11.44L23.64 10.92H22.76L22.48 10.08Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M22.48 14.33L22.21 15.16H21.33L22.04 15.68L21.77 16.52L22.48 16L23.2 16.52L22.92 15.68L23.64 15.16H22.76L22.48 14.33Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M22.76 19.4L22.48 18.57L22.21 19.4H21.33L22.04 19.92L21.77 20.76L22.48 20.24L23.2 20.76L22.92 19.92L23.64 19.4H22.76Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M24.98 3.71997L24.71 4.55997H23.83L24.54 5.06997L24.27 5.90997L24.98 5.38997L25.69 5.90997L25.42 5.06997L26.13 4.55997H25.25L24.98 3.71997Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M24.98 7.95996L24.71 8.79996H23.83L24.54 9.31996L24.27 10.15L24.98 9.63996L25.69 10.15L25.42 9.31996L26.13 8.79996H25.25L24.98 7.95996Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M24.98 12.2L24.71 13.04H23.83L24.54 13.56L24.27 14.4L24.98 13.88L25.69 14.4L25.42 13.56L26.13 13.04H25.25L24.98 12.2Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M24.98 16.45L24.71 17.28H23.83L24.54 17.8L24.27 18.64L24.98 18.12L25.69 18.64L25.42 17.8L26.13 17.28H25.25L24.98 16.45Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 21.52L24.98 20.69L24.71 21.52H23.83L24.54 22.04L24.27 22.88L24.98 22.36L25.69 22.88L25.42 22.04L26.13 21.52H25.25Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M27.47 5.83997L27.2 6.67997H26.32L27.03 7.19997L26.76 8.02997L27.47 7.50997L28.19 8.02997L27.91 7.19997L28.63 6.67997H27.75L27.47 5.83997Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M27.47 10.08L27.2 10.92H26.32L27.03 11.44L26.76 12.27L27.47 11.76L28.19 12.27L27.91 11.44L28.63 10.92H27.75L27.47 10.08Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M27.47 14.33L27.2 15.16H26.32L27.03 15.68L26.76 16.52L27.47 16L28.19 16.52L27.91 15.68L28.63 15.16H27.75L27.47 14.33Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 19.4L27.47 18.57L27.2 19.4H26.32L27.03 19.92L26.76 20.76L27.47 20.24L28.19 20.76L27.91 19.92L28.63 19.4H27.75Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M29.53 5.06997L29.26 5.90997L29.97 5.38997L30.68 5.90997L30.41 5.06997L31.12 4.55997H30.24L29.97 3.71997L29.7 4.55997H28.82L29.53 5.06997Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M29.97 7.95996L29.7 8.79996H28.82L29.53 9.31996L29.26 10.15L29.97 9.63996L30.68 10.15L30.41 9.31996L31.12 8.79996H30.24L29.97 7.95996Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M29.97 12.2L29.7 13.04H28.82L29.53 13.56L29.26 14.4L29.97 13.88L30.68 14.4L30.41 13.56L31.12 13.04H30.24L29.97 12.2Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M29.97 16.45L29.7 17.28H28.82L29.53 17.8L29.26 18.64L29.97 18.12L30.68 18.64L30.41 17.8L31.12 17.28H30.24L29.97 16.45Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M30.24 21.52L29.97 20.69L29.7 21.52H28.82L29.53 22.04L29.26 22.88L29.97 22.36L30.68 22.88L30.41 22.04L31.12 21.52H30.24Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsa);
export default __webpack_public_path__ + "static/media/USA.a380d637c5f0190813f8f5b8aa955345.svg";
export { ForwardRef as ReactComponent };